import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { REDIRECT_TO } from '@store/actions';

@Injectable()
export class CoreEffects {
  constructor(private actions$: Actions, private router: Router) {}

  redirectTo$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(REDIRECT_TO),
        tap(({ path }) => this.router.navigate([path]))
      ),
    { dispatch: false }
  );
}
